import { useEffect } from 'react';

const POLLING_INTERVAL = 5000; // 5 seconds

export const usePolling = ({
  startPolling,
  stopPolling,
  poll,
}: {
  startPolling(_: number): void;
  stopPolling(): void;
  poll: boolean;
}) => {
  useEffect(() => {
    if (!poll) return;

    startPolling(POLLING_INTERVAL);

    return () => stopPolling();
  }, [startPolling, stopPolling, poll]);
};
